<template>
	<div class="member_integral_stategy_container">
		<div class="member_integral_stategy_container_title">如何赚积分</div>
		<div class="member_integral_stategy_container_content">
			<!-- some of one start: -->
			<div class="member_integral_stategy_container_content_inner_of_one" v-for="(item, index) in howToEarnPointsList" :key="item.id">
				<!-- No box: -->
				<div class="No_box">No.{{ index + 1 }}</div>
				<div class="box_top">
					<div class="title">{{ item.title }}</div>
					<div class="desc">{{ item.desc }}</div>
				</div>
				<div class="box_bottom">
					<div class="astrict">{{ item.astrict }}</div>
					<div class="btn" @click="LinkToUrl(item)">{{ item.btnname }}</div>
				</div>
			</div>
			<!-- some of one end -->
		</div>
		<w-login :loginOpen="loginOpen" @LoginClose="LoginClose"></w-login>

		<picture-popup ref="picturePopup"></picture-popup>
	</div>
</template>

<script>
import userStore from '@/store/userStore/userStore.js';
import wlogin from '@components/login/login';
import picturePopup from '@extend/components/work/picture-popup.vue';
export default {
	components: {
		'w-login': wlogin,
		'picture-popup': picturePopup,
	},
	data() {
		return {
			howToEarnPointsList: [
				{
					id: 0,
					title: '消费得积分',
					desc: '消费一元积一分(限达美乐自有官方平台)',
					astrict: '',
					btnname: '去菜单',
					navigate: '/menu',
				},
				{
					id: 1,
					title: '邀请好友得积分',
					desc: '邀请好友下单成功可获比萨券',
					astrict: '',
					btnname: '邀请好友',
					navigate: 'https://member.dominos.com.cn/',
				},
				{
					id: 2,
					title: '完善信息得积分',
					desc: '完善信息得积分',
					astrict: '',
					btnname: '去完善信息',
					navigate: '/mine/info',
				},
				// {
				//   id: 3,
				//   title: "消费得积分",
				//   desc: "消费越多，得分越多",
				//   astrict: "限平台：微信、App、PC",
				//   btnname: "去完善",
				//   navigate: ''
				// },
				{
					id: 4,
					title: '会员中心',
					desc: '查看我的会员详细信息',
					astrict: '',
					btnname: '会员中心',
					navigate: '/mine/info',
				},
			],
			loginOpen: false,
			picShow: false,
		};
	},
	methods: {
		LinkToUrl(data) {
			let loginStatus = userStore.getters.isLogin;
			if ((data.btnname == '去完善信息' || data.btnname == '会员中心') && !loginStatus) {
				this.loginOpen = true;
				return false;
			}
			if (data.id == 1) {
				this.$refs.picturePopup.open();
				return;
			}
			if (data.navigate) {
				if (data.navigate.indexOf('http') > -1) {
					location.href = data.navigate;
				} else {
					this.$router.push({ path: data.navigate });
				}
				try {
					clab_tracker.ready(function() {
						this.track('c_check_coins_stratdgy', { c_buttonName: data.btnname, c_buttonId: data.id });
					});
				} catch (error) {}
			}
		},
		LoginClose() {
			this.loginOpen = false;
		},
	},
};
</script>

<style lang="scss" scoped>
.member_integral_stategy_container {
	padding: 0 130px;
	.member_integral_stategy_container_title {
		height: 80px;
		line-height: 80px;
		text-align: left;
		color: #000;
		font-size: 18px;
		font-weight: bold;
	}
	.member_integral_stategy_container_content {
		display: flex;
		flex-wrap: wrap;
		padding-bottom: 50px;
		.member_integral_stategy_container_content_inner_of_one {
			width: 330px;
			height: 120px;
			border: 1px solid #c49f55;
			float: left;
			margin-right: 40px;
			margin-top: 40px;
			position: relative;
			padding: 20px;
			text-align: left;
			.No_box {
				width: 80px;
				height: 30px;
				background-color: #e1c591;
				color: #fff;
				position: absolute;
				top: -20px;
				left: 10px;
				line-height: 30px;
				font-size: 20px;
				text-align: center;
			}
			.box_top {
				.title {
					color: #000;
					font-weight: bold;
				}
				.desc {
					font-size: 14px;
					line-height: 36px;
				}
			}
			.box_bottom {
				display: flex;
				line-height: 30px;
				justify-content: space-between;
				.astrict {
					font-size: 14px;
				}
				.btn {
					width: 120px;
					height: 30px;
					background-color: #c49f55;
					color: #fff;
					border-radius: 15px;
					text-align: center;
					cursor: pointer;
					&:hover {
						background-color: rgb(111, 89, 43);
					}
				}
			}
		}
	}
}
</style>
